export default __webpack_public_path__ + "static/media/19_header_order.2f20c8bb.png";